// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"c625bbf2","58":"10a7e1ad","60":"97802840","243":"1ec11b06","283":"0140db73","424":"74866dfd","433":"2d4b9d85","439":"5feb0b3b","460":"4d59765a","493":"801db0d8","576":"f8daa0c8","722":"f9e27c3c","914":"3473bafc"}[chunkId] + ".chunk.js";
};